import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import { findArea, findWorkflow } from '@/utils/generalFunctions';

export default {
  data() {
    return {
      loadingAllDataRequired: false,
      contract: null,
      inventory: null,
      area: null,
      fatherArea: null,
      workflows: {
        salud: null,
        seguridad: null,
        medioambiente: null,
      },
      contractPeople: [],
    };
  },
  computed: {
    ...mapGetters({
      usersFaena: 'usersFaena',
    }),
  },
  async created() {
  },
  methods: {
    ...mapActions([
      'getUsersFaena',
      'resetInventory',
    ]),
    async getContract(id) {
      const self = this;
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      };
      await axios.get(`contratos/${id}`, config)
        .then((response) => {
          self.contract = response.data;
          // Para los componentes :/
          self.$store.dispatch('setActualContract', response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getInventory() {
      this.loading = true;
      const self = this;
      await this.$store
        .dispatch('getInventory', this.contract)
        .then(() => {
          self.inventory = self.$store.getters.inventario;
          self.loading = false;
        });
    },
    async getContractArea(id) {
      this.area = await this.getArea(id);
    },
    async getContractFatherArea(id) {
      this.fatherArea = await this.getArea(id);
    },
    async getArea(id) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
      const response = await axios.get(`areas/${id}`, config);
      return response.data;
    },
    async getWorkflowByType(type, id) {
      this.workflows[type] = await this.getWorkflow(id);
    },
    async getWorkflow(id) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
      const response = await axios.get(`workflow/${id}`, config);
      return response.data;
    },
  },
};
